import * as React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import { pickupsContainHealthArmor, pickupsContainPowerUps, pickupsContainSpecialItem, pickupsContainWeaponsAmmo, PickupStatsCategories } from '../../../../helpers';
import { IRoundBoxScoreDto } from '../../../../WorldDoomLeague';
import MatchRoundPickupsTabsView from './MatchRoundPickupsTabsView';
import MatchRoundPickupsCategoriesTabs from './MatchRoundPickupsCategoriesTabs';

interface MatchRoundPickupsStatsProps {
    activeRound: number,
    perRoundBoxScore: IRoundBoxScoreDto[]
};

const MatchRoundPickupsStats = (props: MatchRoundPickupsStatsProps) => {
    const [activeCategoryTab, setActiveCategoryTab] = useState<PickupStatsCategories>();
    const [categories, setCategories] = useState<PickupStatsCategories[]>([]);


    const CreateStatCategories = (round: IRoundBoxScoreDto) => {
        var statcategories = [] as PickupStatsCategories[];

        round.redTeamPlayerRoundBoxScore.map((s, idx) => {
            if (s.pickupStats.length > 0) {
                if (statcategories.every(e => e !== PickupStatsCategories.HealthArmor)) {
                    if (pickupsContainHealthArmor(s.pickupStats)) {
                        statcategories = [...statcategories, PickupStatsCategories.HealthArmor];
                    }
                }

                if (statcategories.every(e => e !== PickupStatsCategories.WeaponsAmmo)) {
                    if (pickupsContainWeaponsAmmo(s.pickupStats)) {
                        statcategories = [...statcategories, PickupStatsCategories.WeaponsAmmo];
                    }
                }

                if (statcategories.every(e => e !== PickupStatsCategories.PowerUps)) {
                    if (pickupsContainPowerUps(s.pickupStats)) {
                        statcategories = [...statcategories, PickupStatsCategories.PowerUps];
                    }
                }

                if (statcategories.every(e => e !== PickupStatsCategories.SpecialItems)) {
                    if (pickupsContainSpecialItem(s.pickupStats)) {
                        statcategories = [...statcategories, PickupStatsCategories.SpecialItems];
                    }
                }
            }
        });

        round.blueTeamPlayerRoundBoxScore.map((s, idx) => {
            if (s.pickupStats.length > 0) {
                if (statcategories.every(e => e !== PickupStatsCategories.HealthArmor)) {
                    if (pickupsContainHealthArmor(s.pickupStats)) {
                        statcategories = [...statcategories, PickupStatsCategories.HealthArmor];
                    }
                }

                if (statcategories.every(e => e !== PickupStatsCategories.WeaponsAmmo)) {
                    if (pickupsContainWeaponsAmmo(s.pickupStats)) {
                        statcategories = [...statcategories, PickupStatsCategories.WeaponsAmmo];
                    }
                }

                if (statcategories.every(e => e !== PickupStatsCategories.PowerUps)) {
                    if (pickupsContainPowerUps(s.pickupStats)) {
                        statcategories = [...statcategories, PickupStatsCategories.PowerUps];
                    }
                }

                if (statcategories.every(e => e !== PickupStatsCategories.SpecialItems)) {
                    if (pickupsContainSpecialItem(s.pickupStats)) {
                        statcategories = [...statcategories, PickupStatsCategories.SpecialItems];
                    }
                }
            }
        });

        return statcategories;
    };

    useEffect(() => {
        var newcats = CreateStatCategories(props.perRoundBoxScore[props.activeRound - 2]);

        if (newcats.length > 0) {
            setCategories(newcats);
            setActiveCategoryTab(newcats[0]);
        }
    }, [props.activeRound]);

    return (
        <React.Fragment>
            <Row>
                <Col>
                    <Card className='bg-dark mb-3'>
                        <CardHeader>
                            Item Pickups
                        </CardHeader>
                        <CardBody>
                            <MatchRoundPickupsCategoriesTabs
                                activeCategoryTab={activeCategoryTab}
                                setActiveCategoryTab={setActiveCategoryTab}
                                categories={categories}
                            />
                            <MatchRoundPickupsTabsView
                                category={activeCategoryTab}
                                perRoundBoxScore={props.perRoundBoxScore[props.activeRound - 2]}
                                categoriesObject={categories}
                                activeRound={props.activeRound}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default MatchRoundPickupsStats;